<script setup>
import { reactive, watch } from 'vue'
import FieldPicker from '../shared/FieldPicker.vue'

const props = defineProps({
    node: Object,
})

const emit = defineEmits(['update:config'])

const triggerTypes = [
    { value: 'contact_created', label: 'Contact Created' },
    { value: 'field_changed', label: 'Field Changed' },
    { value: 'tag_assigned', label: 'Tag Assigned' },
    { value: 'form_submitted', label: 'Form Submitted' },
    { value: 'date_field_reached', label: 'Date Reached' },
]

const form = reactive({
    trigger_type: props.node?.data?.config?.trigger_type ?? 'contact_created',
    trigger_config: props.node?.data?.config?.trigger_config ?? {},
})

watch(() => props.node, (node) => {
    if (!node) return
    form.trigger_type = node.data?.config?.trigger_type ?? 'contact_created'
    form.trigger_config = node.data?.config?.trigger_config ?? {}
})

function emitUpdate() {
    emit('update:config', { trigger_type: form.trigger_type, trigger_config: form.trigger_config })
}
</script>

<template>
    <div class="config-panel__section">
        <label class="config-panel__label">Trigger Type</label>
        <select v-model="form.trigger_type" class="config-panel__select" @change="emitUpdate">
            <option v-for="t in triggerTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
        </select>

        <template v-if="form.trigger_type === 'field_changed'">
            <label class="config-panel__label">Field to Watch</label>
            <FieldPicker
                v-model="form.trigger_config.field"
                placeholder="Select field..."
                @update:modelValue="emitUpdate"
            />
        </template>

        <template v-if="form.trigger_type === 'tag_assigned'">
            <label class="config-panel__label">Tag ID</label>
            <input
                v-model.number="form.trigger_config.tag_id"
                class="config-panel__input"
                type="number"
                placeholder="Tag ID"
                @input="emitUpdate"
            />
        </template>

        <template v-if="form.trigger_type === 'form_submitted'">
            <label class="config-panel__label">Form ID</label>
            <input
                v-model.number="form.trigger_config.form_id"
                class="config-panel__input"
                type="number"
                placeholder="Form ID"
                @input="emitUpdate"
            />
        </template>

        <template v-if="form.trigger_type === 'date_field_reached'">
            <label class="config-panel__label">Date Field</label>
            <FieldPicker
                v-model="form.trigger_config.field"
                filter-type="date"
                placeholder="Select date field..."
                @update:modelValue="emitUpdate"
            />
            <label class="config-panel__label">Offset (days)</label>
            <input
                v-model.number="form.trigger_config.offset_days"
                class="config-panel__input"
                type="number"
                placeholder="0"
                @input="emitUpdate"
            />
        </template>
    </div>
</template>
